// React
import React, { useState, useEffect } from 'react';
import i18next from 'i18next';
import { useSelector, useDispatch } from 'react-redux';

//Components
import { Dialog, MpsSectionedForm } from '@mobilitystore/components-interface';
import { StepIndicator } from '../../../../msreact-kit/packages/html-components';

// Actions
import { getReadyToShipComments } from '../../../../actions/shipment-service-action';

// Data
import { consignmentDynamicFormFields } from '../data';

// Utils
import { convertUTCToLocalDateFormat } from '../../../../utils/date-time-utils';
import { handleDownloadInvoice } from '../../order-summary-page/utils';
import {
  getColourNode,
  orderStatus as orderStatusList
} from '../../../../shared/shared-function/helperFunctions';

// Css
import './index.scss';

const OrderStatus = (props) => {
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const [showConsignmentPopup, setShowConsignmentPopup] = useState(false);
  const [updatedConsignmentFields, setUpdatedConsignmentFields] = useState(
    consignmentDynamicFormFields
  );
  const orderStatus = useSelector((state) => state.OrderSummaryReducer.orderStatus);

  const handleInputChange = () => {};
  const handleDownloadInvoiceDoc = () => {
    handleDownloadInvoice(dispatch, props?.productOrderId, props?.tenantId);
  };

  useEffect(() => {
    if (orderStatus.length > 0) {
      const sortedOrderStatus = [...orderStatus].sort(
        (a, b) => Number(a.displayOrder) - Number(b.displayOrder)
      );
      const formatedNewData = sortedOrderStatus.map((element) => {
        let displayName = '';
        switch (element.status) {
          case orderStatusList.ORDER_CREATED:
            displayName = i18next.t('ORDER_MANAGEMENT.ORDER_STATUS.CREATED');
            break;
          case orderStatusList.ORDER_CONFIRMED:
            displayName = i18next.t('ORDER_MANAGEMENT.ORDER_STATUS.CONFIRMED');
            break;
          case orderStatusList.INTRANSIT:
            displayName = i18next.t('ORDER_MANAGEMENT.ORDER_STATUS.INTRANSIT');
            break;
          case orderStatusList.REJECTED_WITH_POD:
            displayName = i18next.t(
              'ORDER_MANAGEMENT.ORDER_STATUS.REJECTED_WITH_POD'
            );
            break;
          case orderStatusList.ORDER_REJECTED:
            displayName = i18next.t('ORDER_MANAGEMENT.ORDER_STATUS.REJECTED');
            break;
          case orderStatusList.ORDER_CANCELLED:
          case orderStatusList.CONFIRMED_ORDER_CANCELLED:
            displayName = i18next.t('ORDER_MANAGEMENT.ORDER_STATUS.CANCELLED');
            break;
          case orderStatusList.POST_PAYMENT:
            displayName = i18next.t('ORDER_MANAGEMENT.ORDER_STATUS.PAYMENT');
            break;
          default:
            displayName = element?.status?.split('_').join(' ');
            break;
        }

        return {
          displayName:
            element.status === orderStatusList.REJECTED_WITH_POD
              ? displayName
              : displayName.charAt(0).toUpperCase() +
                displayName.slice(1).toLowerCase(),
          desc: element.statusUpdateTime
            ? convertUTCToLocalDateFormat(
                element.statusUpdateTime,
                'DD/MM/YYYY, h:mm A'
              )
            : '',
          ...element
        };
      });
      setData(formatedNewData);
    }
  }, [orderStatus]);

  const populateConsignmentFields = (fields, dataObj) => {
    fields?.forEach((section) => {
      section.fields?.forEach((field) => {
        switch (field.name) {
          case 'noOfBoxes':
            field.value = dataObj.shipmentDimension?.noOfBoxes || '';
            field.disabled = true;
            break;
          case 'weight':
            field.value = dataObj.shipmentDimension?.weight || '';
            field.disabled = true;
            break;
          case 'dimensions':
            if (field.type === 'COMBINE') {
              field.attributes.forEach((attr) => {
                attr.value = dataObj.shipmentDimension?.[attr.name] || '';
                attr.disabled = true;
              });
            }
            break;
          case 'invoiceNo':
            field.value = dataObj.invoiceDetail?.invoiceNo || '';
            field.disabled = true;
            break;
          case 'invoiceDate':
            field.value = dataObj.invoiceDetail?.invoiceDate || '';
            field.disabled = true;
            break;
          case 'pickupLocation':
            field.value = dataObj.pickupLocation?.name || '';
            field.disabled = true;
            field.options = [
              {
                label: dataObj.pickupLocation?.name || '',
                value: dataObj.pickupLocation?.name || ''
              }
            ];
            break;
          default:
            break;
        }
      });
      if (section.id === 'invoice-section' && section.headerAction) {
        section.headerAction.onClick = handleDownloadInvoiceDoc;
      }
    });
    return fields;
  };

  const handleReadyToShipPopup = (index) => {
    if (!props?.isPlatformFullfillmentFlow) return;
    const readyToShipIndex = data.findIndex((item) =>
      item.displayName.includes(
        i18next.t('ORDER_MANAGEMENT.ORDER_STATUS.READY_TO_SHIP')
      )
    );
    if (index === readyToShipIndex) {
      if (props?.productOrderId) {
        dispatch(getReadyToShipComments(props?.productOrderId)).then(
          (apiResponse) => {
            if (apiResponse) {
              const clonedFields = JSON.parse(
                JSON.stringify(consignmentDynamicFormFields)
              );
              setUpdatedConsignmentFields(
                populateConsignmentFields(clonedFields, apiResponse)
              );
            }
            setShowConsignmentPopup(true);
          }
        );
      }
    }
  };

  const handleCloseConsignmentPopup = () => {
    setShowConsignmentPopup(false);
  };

  const currentCount = getColourNode(data);
  const activeGrouping = currentCount.currentNode;
  const size = currentCount.maxLength;
  if (size < 1) return null;

  return (
    <>
      <hr className='a-divider -within-text' />
      <div className='order-status'>
        <h5 className='order-status__header'>
          {i18next.t('ORDER_MANAGEMENT.ORDER_STATUS.STATUS')}
        </h5>
        <div className='order-status__indicator mobile-indicator'>
          <div className='order-status__indicator m-step-indicator m-step-indicator--mobile -small'>
            <StepIndicator
              size={size}
              data={data}
              active={activeGrouping}
              customClass='order-status-node'
              handleClick={
                props?.isPlatformFullfillmentFlow && activeGrouping > 1
                  ? handleReadyToShipPopup
                  : undefined
              }
              handleHover={
                props?.isPlatformFullfillmentFlow
                  ? handleReadyToShipPopup
                  : undefined
              }
              pointerIndex={
                props?.isPlatformFullfillmentFlow
                  ? data.findIndex((item) =>
                      item.displayName.includes(
                        i18next.t('ORDER_MANAGEMENT.ORDER_STATUS.READY_TO_SHIP')
                      )
                    )
                  : undefined
              }
              clickableSteps={
                props?.isPlatformFullfillmentFlow && activeGrouping > 1
                  ? [
                      data.findIndex((item) =>
                        item.displayName.includes(
                          i18next.t('ORDER_MANAGEMENT.ORDER_STATUS.READY_TO_SHIP')
                        )
                      )
                    ]
                  : []
              }
            />
          </div>
        </div>
      </div>
      {showConsignmentPopup && (
        <Dialog
          className='dialog-popup'
          show={true}
          showPopup={true}
          showCloseIcon={true}
          onClose={handleCloseConsignmentPopup}
        >
          <MpsSectionedForm
            sections={updatedConsignmentFields}
            handleInputChange={handleInputChange}
            className=''
          />
        </Dialog>
      )}
    </>
  );
};

export default OrderStatus;
